Object.defineProperty(exports, "__esModule", { value: true });
exports.getClassWithAllParentClasses = void 0;
function getClassWithAllParentClasses(target) {
    const result = [target];
    let currentNode = target;
    while (Object.getPrototypeOf(currentNode)) {
        const parent = Object.getPrototypeOf(currentNode);
        if (parent === Function.prototype)
            break;
        result.push(parent);
        currentNode = parent;
    }
    return result.reverse(); // reverse so we go from parents to children
}
exports.getClassWithAllParentClasses = getClassWithAllParentClasses;
//# sourceMappingURL=index.js.map